import React from "react";
import { Card, Button, ListGroup, Media } from "react-bootstrap";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import CenteredLoadingIndicator from "../../sharedComponents/centeredLoadingIndicator";
import FlameRating from "../../sharedComponents/flameRating";
import { slice } from "lodash";
import NoContent from "../../sharedComponents/noItemFoundAlert";
import "./home.scss";

export default function featuredExercises({ featuredExercises, history }) {
	return (
		<Card className="featured-exercise-card-container">
			<Card.Header className="card-header">Featured Exercises</Card.Header>
			{featuredExercises ? (
				featuredExercises.length ? (
					<div className="list-container">
						<ListGroup variant="flush">
							{slice(featuredExercises, 0, 3).map((item) => (
								<ListGroup.Item key={item.id}>
									<Media
										className="pointer"
										onClick={() => history.push(`/fitness/exercises/${item.id}/details`)}>
										<PlaceholderImage
											src={item.main_image.data}
											width={60}
											height={60}
											className="mr-3 img-custom-style"
											bg="rgba(0,0,0,0.1)"
											color="rgba(0,0,0,0.3)"
											objectFit="cover"
										/>
										<Media.Body>
											<h5 className="item-title">{item.name}</h5>
											<div className="item-content-container">
												<FlameRating value={item.flame_value} />
												<p>{item.flame}</p>
											</div>
										</Media.Body>
									</Media>
								</ListGroup.Item>
							))}
						</ListGroup>
						<Button
							variant="outline-secondary"
							className="footer-button"
							onClick={() => history.push("./fitness/exercises")}>
							View And Search All Excercises
						</Button>
					</div>
				) : (
					<div className="m-3">
						<NoContent />
					</div>
				)
			) : (
				<CenteredLoadingIndicator />
			)}
		</Card>
	);
}
